import type { ComponentType } from 'react'
import type { RouteObject } from 'react-router-dom'
import { createPermissionGuardedPage } from '@/shared/components/create-permission-guarded-page'
import { importWithChunkReload } from '@/shared/lib/chunk-load-recovery'
import { InterviewIntakePermissions } from './permissions'

async function lazyGuardedRoute(
  importPage: () => Promise<Record<string, ComponentType>>,
  exportName: string,
  perm: string | readonly string[],
): Promise<{ Component: ComponentType }> {
  const mod = await importWithChunkReload(importPage)
  const Page = mod[exportName]
  if (!Page) {
    throw new Error(`Interview intake page export "${exportName}" not found`)
  }
  return { Component: createPermissionGuardedPage(perm, Page) }
}

export const interviewIntakeRoutes: RouteObject[] = [
  {
    path: 'hr/interview-applications',
    lazy: () =>
      lazyGuardedRoute(
        () => import('./pages/interview-applications-page'),
        'InterviewApplicationsPage',
        InterviewIntakePermissions.access,
      ),
  },
  {
    path: 'hr/interview-applications/:id',
    lazy: () =>
      lazyGuardedRoute(
        () => import('./pages/interview-application-detail-page'),
        'InterviewApplicationDetailPage',
        InterviewIntakePermissions.access,
      ),
  },
]
